import { PaginatedResult } from '../../../models';
import { getQueryURL } from '../requestService';
import { client } from '../../client';
import RequestTreeService from '../requestTreeService';
import { OrdningsVerdiLight } from '../../../models/ordningsVerdiLight';


export default class OrdningsVerdiLightService extends RequestTreeService<OrdningsVerdiLight, 'ordningsVerdiLight'> {
    constructor(serviceName: 'ordningsVerdiLight') {
        super(serviceName);
        this.idKey = 'uniqueId';
    }

    childrenLight = async (parentId: number) => client.get<OrdningsVerdiLight[]>(getQueryURL(`${this.serviceName}/${parentId}/childrenLight`));
    childrenLightStringId = async (parentId: string) => client.get<OrdningsVerdiLight[]>(getQueryURL(`${this.serviceName}/${encodeURIComponent(parentId)}/childrenLightStringId`));
    allTreeItemsLight = async (eksternId: string) => client.get<OrdningsVerdiLight[]>(getQueryURL(`${this.serviceName}/${encodeURIComponent(eksternId)}/allTreeItemsLight`));

    ordningsVerdiByOrdningsprinsippUniqueId =
        async (uniqueId: number, searchString: string) =>
            client.get<PaginatedResult<OrdningsVerdiLight>>
                (`${this.serviceName}/${encodeURIComponent(uniqueId)}/ordningsVerdiByOrdningsprinsippUniqueId?q=${encodeURIComponent(searchString)}&disablePagination=true`);

    ordningsVerdiByUniqueId =
        async (ordningsverdiId: string) =>
            client.get<OrdningsVerdiLight>(`${this.serviceName}/${encodeURIComponent(ordningsverdiId)}/ordningsVerdiByUniqueIdEllerSammensatt`) as unknown as OrdningsVerdiLight;

    hentOrdningsVerdiLightListe =
        async (searchString: string) =>
            client.get<OrdningsVerdiLight[]>
                (`${this.serviceName}/hentOrdningsverdiLight?q=${encodeURIComponent(searchString)}`);

    hentOrdningsVerdiListe =
        async (searchString: string) =>
            client.get<OrdningsVerdiLight[]>
                (`${this.serviceName}/hentOrdningsverdiListe?q=${encodeURIComponent(searchString)}`);

 
  override update(item: OrdningsVerdiLight) {
        return client.post<OrdningsVerdiLight>(`${this.serviceName}/${encodeURIComponent(item.uniqueId!)}`, item);
    
}
}
